import { Fragment, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { isEmpty } from 'lodash'

import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import Heading from 'components/v2/Heading'
import { StyledLink } from 'components/v2/Link'
import Modal from 'components/v2/Modal'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from '@10xLabs/react-web/components/Table'
import { TotalWithDiscount } from 'components/TotalWithDiscount'
import { isCombo, getProductsCountByCombo } from 'resolvers/items'
import { getLineItemTotal } from 'resolvers/sales'
import { round } from 'utils/math'

const ComboComponentName = styled.div<TSFixMe>`
  margin-left: 30px;
`

const StyledTr = styled(Tr)<TSFixMe>`
  background: ${(props): TSFixMe => (props.isEven ? '#f8f9fc' : '#ffffff')}!important;
`

const ComponentTd = styled(Td)<TSFixMe>`
  padding-top: 0;
`

export const LineItems = ({ lineItems }: TSFixMe): TSFixMe => {
  const [isModalOpen, setModalOpen] = useState(false)

  const totalItems = lineItems.reduce((result: TSFixMe, lineItem: TSFixMe): TSFixMe => {
    if (isCombo({ item: lineItem })) {
      return result + getProductsCountByCombo(lineItem)
    }
    return result + lineItem.quantity
  }, 0)

  return (
    <>
      {totalItems > 0 ? <StyledLink onClick={(): TSFixMe => setModalOpen(true)}>{totalItems}</StyledLink> : 0}

      {isModalOpen && (
        <Modal.Container large>
          <Modal.Header onClose={(): TSFixMe => setModalOpen(false)}>
            <Heading.H5>
              <FormattedMessage id="spanish.sales.lineItems.title" defaultMessage="Productos" />
            </Heading.H5>
          </Modal.Header>

          <Modal.Content>
            <TableContainer overflow>
              <Table>
                <Thead>
                  <Tr>
                    <Th>
                      <FormattedMessage id="spanish.dictionary.product" defaultMessage="Producto" />
                    </Th>

                    <Th>
                      <FormattedMessage id="spanish.dictionary.quantity" defaultMessage="Cantidad" />
                    </Th>

                    <Th>
                      <FormattedMessage id="spanish.sales.lineItems.sellingPrice.label" defaultMessage="Precio" />
                    </Th>

                    <Th>
                      <FormattedMessage id="spanish.dictionary.total" defaultMessage="Total" />
                    </Th>
                  </Tr>
                </Thead>

                <Tbody>
                  {lineItems.map((lineItem: TSFixMe, index: TSFixMe): TSFixMe => {
                    const itemIsCombo = !isEmpty(lineItem.comboComponents)
                    const isEven = (index + 1) % 2 === 0

                    return (
                      <Fragment key={index}>
                        <StyledTr isEven={isEven}>
                          <Td>{lineItem.name}</Td>

                          <Td>{lineItem.quantity}</Td>

                          <Td>
                            <FormattedPrice value={lineItem.unitPrice} hideCurrency />
                          </Td>

                          <Td>
                            <TotalWithDiscount total={getLineItemTotal(lineItem)} discount={lineItem.discount} />
                          </Td>
                        </StyledTr>

                        {itemIsCombo && (
                          <>
                            {lineItem.comboComponents.map((component: TSFixMe, componentIndex: TSFixMe): TSFixMe => {
                              return (
                                <StyledTr key={componentIndex} isEven={isEven}>
                                  <ComponentTd>
                                    <ComboComponentName>{component.item.name}</ComboComponentName>
                                  </ComponentTd>

                                  <ComponentTd>{round(lineItem.quantity * component.quantity)}</ComponentTd>

                                  <ComponentTd />

                                  <ComponentTd />
                                </StyledTr>
                              )
                            })}
                          </>
                        )}
                      </Fragment>
                    )
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Modal.Content>
        </Modal.Container>
      )}
    </>
  )
}
